/* Shapes.js */

const { Area } = require('./Area');
const { Distance } = require('./Distance');

module.exports = {
  Area,
  Distance
}